import React from "react";
 import { Navigate } from "react-router-dom";
import { isAuthenticated, hasRole } from "./auth"; // Import updated utilities

const ProtectedRoute = ({ children, roles = [] }) => {
  // Check if the user is authenticated
  if (!isAuthenticated()) {
    return <Navigate to="/account" replace />;
  }

  // Validate roles if provided
  if (roles.length > 0) {
   // const userRoles = getUserRoles();
    const hasRequiredRole = roles.some((role) => hasRole(role));

    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  // Render children if authenticated and authorized
  return children;
};

export default ProtectedRoute;
